window.loadSwiper = window.loadSwiper || function() {
    if (window.Swiper) return Promise.resolve();
    if (window._swiperLoading) return window._swiperLoading;
  
    window._swiperLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = '{{ "swiper-bundle.min.js" | asset_url }}';
      script.onload = () => resolve();
      script.onerror = reject;
      script.defer = true;
      document.body.appendChild(script);
    });
  
    return window._swiperLoading;
  };